import { toast } from 'react-toastify'
import { checkAccess } from '../api/company'
import { getAccount } from '../api/user'
import {
  IMPERSONATE,
  SET_ACCOUNT,
  SWITCH_COMPANY,
  TOKEN_AUTH,
  TOKEN_OAUTH,
} from '../reducers/auth'
import { trans } from '../utils/utilsTrans'

export const auth = (keycloak_data, user_account) => {
  return async (dispatch) => {
    const current = localStorage.getItem('keycloak_data')

    if (keycloak_data || keycloak_data?.token !== current?.token) {
      localStorage.setItem('keycloak_data', JSON.stringify(keycloak_data))
      dispatch({ type: TOKEN_AUTH, keycloak_data })
    }
  }
}

export const googleOauth = (data) => {
  return async (dispatch) => {
    const current = JSON.parse(localStorage.getItem('google_data') ?? '{}')

    if (data || data?.access_token !== current?.access_token) {
      localStorage.setItem('google_data', JSON.stringify(data))
      dispatch({ type: TOKEN_OAUTH, data })
    }
  }
}

export const impersonateAdmin = (user) => {
  return async (dispatch) => {
    const impersonate_data = {
      id: user.id,
      email: user.email,
      firstname: user.firstname,
      lastname: user.lastname,
    }

    dispatch({ type: IMPERSONATE, impersonate_data })
    localStorage.setItem('impersonate_data', JSON.stringify(impersonate_data))
    const account = await getAccount()
    dispatch({ type: SET_ACCOUNT, data: account })
  }
}

export const cancel_impersonate = () => {
  return async (dispatch) => {
    dispatch({
      type: IMPERSONATE,
      impersonate_data: null,
    })
    localStorage.removeItem('impersonate_data')
    const account = await getAccount()
    dispatch({ type: SET_ACCOUNT, data: account })
  }
}

export const switchCompany = (company) => {
  return (dispatch) => {
    return checkAccess(company.id)
      .then((res) => {
        //check access for this company
        dispatch({ type: SWITCH_COMPANY, data: company, currentRole: res })
        localStorage.setItem('current_company', JSON.stringify(company))
        return true
      })
      .catch(() => {
        toast.error(trans('company.unauthorized'))
        return false
      })
  }
}
